import client from 'api/client';
import { AxiosResponse } from 'axios';

export function get(id: number): Promise<AxiosResponse> {
    const url = `/candidate-profile/${id}`;
    return client.get(url);
}
